var _defs, _path, _g, _ellipse, _ellipse2, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "No_Result",
    width: 204,
    height: 156,
    "data-name": "No Result",
    viewBox: "0 0 204 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#afafaf}.cls-3{fill:#d7d7d7}.cls-4{fill:#e5e5e5}.cls-10,.cls-12{fill:none}.cls-12{stroke:#afafaf}.cls-10{stroke-linecap:round}.cls-10,.cls-12{stroke-miterlimit:10}.cls-9{fill:#0c65a7}.cls-10{stroke:#0c65a7;stroke-width:10px}.cls-12{stroke-width:6px}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2030",
    fill: "rgba(255,255,255,0)",
    d: "M0 0H204V156H0z",
    "data-name": "Rectangle 2030"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3915",
    "data-name": "Group 3915",
    transform: "translate(.002 .002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5930",
    d: "M4.261 0C3.627 3.622 0 5.118 0 5.118l3.932 2.523A9.44 9.44 0 0 0 8 1.575z",
    className: "cls-2",
    "data-name": "Path 5930",
    transform: "rotate(-88 28.074 -4.616)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    transform: "translate(13.621 33.755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6432",
    d: "M90.782 218.288a5.8 5.8 0 1 1 5.847-5.8 5.827 5.827 0 0 1-5.847 5.8zm0-9.343a3.548 3.548 0 1 0 3.58 3.548 3.568 3.568 0 0 0-3.58-3.548z",
    className: "cls-3",
    "data-name": "Path 6432",
    transform: "translate(-84.933 -206.698)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5927",
    d: "M68.485 168.211l.969-2.293a.487.487 0 0 1 .892 0l.968 2.293a5.891 5.891 0 0 0 2.625 2.884l1.447.786a.478.478 0 0 1 .2.649.486.486 0 0 1-.2.2l-1.447.785a5.891 5.891 0 0 0-2.625 2.884l-.968 2.294a.487.487 0 0 1-.892 0l-.969-2.294a5.893 5.893 0 0 0-2.624-2.884l-1.447-.785a.478.478 0 0 1 0-.848l1.447-.786a5.893 5.893 0 0 0 2.624-2.885z",
    className: "cls-4",
    "data-name": "Path 5927",
    transform: "translate(-64.156 -165.626)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_912",
    cx: 72.955,
    cy: 72.15,
    fill: "url(#linear-gradient)",
    "data-name": "Ellipse 912",
    opacity: 0.5,
    rx: 72.955,
    ry: 72.15,
    transform: "translate(42.026 2.452)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_913",
    cx: 36.478,
    cy: 36.149,
    fill: "url(#linear-gradient-2)",
    "data-name": "Ellipse 913",
    opacity: 0.3,
    rx: 36.478,
    ry: 36.149,
    transform: "translate(16.063 64.758)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3977",
    "data-name": "Group 3977",
    transform: "translate(40.254 22.933)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6508",
    d: "M223.789 249.453h-84.031a7.138 7.138 0 0 0-7.12 6.334l-5.612 51.405a7.121 7.121 0 0 0 7.12 7.86h84.031a7.138 7.138 0 0 0 7.12-6.333l5.612-51.405a7.122 7.122 0 0 0-7.12-7.861z",
    className: "cls-2",
    "data-name": "Path 6508",
    transform: "translate(-109.692 -212.891)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3974",
    "data-name": "Group 3974",
    transform: "translate(24.481 4.42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2018-2",
    width: 73.83,
    height: 83.612,
    className: "cls-4",
    "data-name": "Rectangle 2018-2",
    rx: 8,
    transform: "rotate(-2.752 73.521 1.766)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3920",
    "data-name": "Group 3920",
    transform: "translate(34.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3975",
    "data-name": "Group 3975"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2019-2",
    width: 83.629,
    height: 73.845,
    fill: "#fefefe",
    "data-name": "Rectangle 2019-2",
    rx: 8,
    transform: "rotate(-85.982 44.733 41.702)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3919",
    "data-name": "Group 3919",
    transform: "translate(11.443 16.661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3916",
    "data-name": "Group 3916",
    transform: "translate(3.079)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_914",
    cx: 4.409,
    cy: 4.37,
    className: "cls-2",
    "data-name": "Ellipse 914",
    rx: 4.409,
    ry: 4.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_342",
    fill: "none",
    stroke: "#afafaf",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "8px",
    d: "M0 0L34.376 2.395",
    "data-name": "Line 342",
    transform: "translate(17.591 5.288)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3917",
    "data-name": "Group 3917",
    transform: "translate(1.539 21.695)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_915",
    cx: 4.409,
    cy: 4.37,
    className: "cls-9",
    "data-name": "Ellipse 915",
    rx: 4.409,
    ry: 4.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_343",
    d: "M0 0L34.376 2.395",
    className: "cls-10",
    "data-name": "Line 343",
    transform: "translate(17.591 5.288)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3918",
    "data-name": "Group 3918",
    transform: "translate(0 43.39)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_916",
    cx: 4.409,
    cy: 4.37,
    className: "cls-9",
    "data-name": "Ellipse 916",
    rx: 4.409,
    ry: 4.37
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_344",
    d: "M0 0L34.376 2.395",
    className: "cls-10",
    "data-name": "Line 344",
    transform: "translate(17.591 5.288)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6509",
    d: "M212.017 315.052h-91.089a7.143 7.143 0 0 1-7.069-5.96l-8.418-51.405a7.118 7.118 0 0 1 7.069-8.234h91.09a7.142 7.142 0 0 1 7.069 5.96l8.418 51.406a7.117 7.117 0 0 1-7.07 8.233z",
    className: "cls-3",
    "data-name": "Path 6509",
    transform: "translate(-103.551 -212.891)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6510",
    d: "M143.806 270.239h-30.13a7.143 7.143 0 0 1-7.069-5.961l-3.674-22.435A7.118 7.118 0 0 1 110 233.61h30.131a7.143 7.143 0 0 1 7.069 5.96l3.674 22.436a7.118 7.118 0 0 1-7.068 8.233z",
    className: "cls-3",
    "data-name": "Path 6510",
    transform: "translate(-102.839 -208.292)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3976",
    "data-name": "Group 3976",
    opacity: 0.5,
    transform: "translate(38.379 49.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_926",
    className: "cls-12",
    "data-name": "Ellipse 926"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.052,
    cy: 20.052,
    r: 20.052
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.052,
    cy: 20.052,
    r: 17.052,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line_347",
    d: "M0 28.246L28.246 0",
    className: "cls-12",
    "data-name": "Line 347",
    transform: "translate(5.578 5.668)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_3914",
    "data-name": "Group 3914",
    transform: "rotate(90 50.341 153.636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5922",
    d: "M5.682 9.569C4.7 5.057 0 3.35 0 3.35L4.9 0a11.85 11.85 0 0 1 5.483 7.419z",
    className: "cls-3",
    "data-name": "Path 5922",
    transform: "scale(-1) rotate(-88 -13.388 13.518)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_911",
    cx: 2.717,
    cy: 2.741,
    fill: "#bac0c3",
    "data-name": "Ellipse 911",
    opacity: 0.8,
    rx: 2.717,
    ry: 2.741,
    transform: "translate(0 23.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6431",
    d: "M3.562 0s2.9 3.163 5.792 2.034c0 0-3.646 2.54-4.6 6.037A4.881 4.881 0 0 1 0 5.665S.273 2.907 3.562 0z",
    className: "cls-3",
    "data-name": "Path 6431",
    transform: "translate(29.082 26.414)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default __webpack_public_path__ + "static/media/no-result.97293b8819c43dc6f3e3a4a8f2eb6c5a.svg";
export { ForwardRef as ReactComponent };